import React from 'react';
import PropTypes from 'prop-types';

export const Progress = (props) => {
  const {
    progressPercentage,
  } = props;

  const styles = { width: `${progressPercentage * 100}%` };

  return (
    <div className="progress">
      <div
        className="progress-bar"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        style={styles}
      />
    </div>
  );
};

Progress.propTypes = {
  progressPercentage: PropTypes.number,
};

Progress.defaultProps = {
  progressPercentage: 0.2,
};

